module.exports = __webpack_public_path__ + "img/slide-20.b882a05a.jpg";